export default __webpack_public_path__ + "static/media/CU.2bdff072.svg";